module.exports = __webpack_public_path__ + "img/saba_matza_yes.58f0b269.png";